/*! Copyright 2025 Lane Crawford, All Rights Reserved. */


( function( LC, $ ) {

	"use strict";

	/**
	 *
	 * signin.signin
	 * global sign in module for submitting the login forms
	 *
	 * @param  {Object} exports | public-access object of methods/properties
	 * @param  {Object} _this   | private-scoped object of methods/properties
	 * @return {Object}         | return the public-access object
	 */
	new lcmodule2( "signin.signin", function( exports, _this ) {

		// "ex" is short-hand for exports (public access) object
		var ex = exports;

		/**
		 * setup() is executed when module is created
		 * but before the DOM is ready.
		 */
		ex.setup = function() {

		};

		/**
		 * initialise the signin module
		 */
		ex.init = function() {

			// initialisation code

			_this.$form = $("#socialLoginStyleSignInForm");
			_this.$forgotPassword = _this.$form.find(".sign-in-form__forgot-password");
			_this.$submit = _this.$form.find(".sign-in-form__submit");

			_this.postUrl = _this.$form.attr("action");
			_this.successUrl = "/account/accountDetails.jsp";

			ex.events();
			ex.subscribe();

		};

		_this.sendForm = function() {

			// we wait a short amount of time, as it's
			// not nice for the user to see flashing preloaders
			// if the response is very fast.
			_this.preloadTimer = setTimeout( function() {
				LC.pubsub.trigger("preloader.open");
			}, 300 );

			_this.ajax = $.ajax({

				url: _this.postUrl,
				type: "POST",
				data: _this.$form.serialize(),
				dataType: "json"

			})

				.done( _this.submitSuccess )

				.always( function() {

					clearTimeout( _this.preloadTimer );
					LC.pubsub.trigger("preloader.close");

				});

		};

		/**
		 * handling for the successful response from
		 * the server after submitting the form
		 *
		 * @param  { Object } response | ATG Form Submit Response
		 */
		_this.submitSuccess = function( response ) {

			var errorObject,
				success = response && (response.isProcessSuccess);

			if ( success ) {

				_this.signinSuccess( response );

			} else {

				_this.signinFailure( response );

				// object to send to form error handler,
				// and sign-in verification handler
				errorObject = {

					form: "#socialLoginStyleSignInForm",
					response: response

				};

				// show the form errors, and
				// run the account-verification check
				LC.pubsub.trigger("forms.showErrors", errorObject );
				LC.pubsub.trigger("forms.verifyCheck", errorObject );

			}

		};

		/**
		 * handling for submitting the registration form,
		 * or showing an email prompt.
		 */
		_this.submitForm = function() {

			LC.track.trigger( "ga.event", {
				eventName: "login_attempt",
				eventData: { method: "form", type: "signin_page", page: LC.location.pathname }
			});

			_this.sendForm();

		};

		_this.signinSuccess = function( response ) {

			// save the redirect url, it might be in the
			// atg response from the server.
			var redirect = response.ajaxSuccessRedirectUrl || _this.successUrl;

			LC.track.trigger( "ga.event", {
				eventName: "login",
				eventData: { method: "form", type: "signin_page", page: LC.location.pathname }
			});

			LC.pubsub.trigger("preloader.open");
			LC.location.href = redirect;

		};

		_this.signinFailure = function( response ) {

			LC.track.trigger( "ga.event", {
				eventName: "login_failure",
				eventData: { method: "form", type: "signin_page", page: LC.location.pathname }
			});

		};

		ex.events = function() {

			_this.$submit
				.off(".signinSubmit")
				.on("click.signinSubmit", function(e) {

					e.preventDefault();
					_this.submitForm();

				});

			_this.$forgotPassword
				.off(".signinPassword")
				.on( "click.signinPassword", function(e) {

					e.preventDefault();
					LC.pubsub.trigger("global.forgotPassword");

				});

		};

		ex.subscribe = function() {

		};

		return exports;

	});

}( window.LC = window.LC || {}, jQuery ));

 //# sourceURL=signin.js
